// Report-param grammar for the extended open-ended family, ported from the coffee block and the
// list views under it.
//
// Four params carry the block's state, addressed by prefix:
//   cm   the chart's mode
//   z    the chart's zoom (shared with the other views of the question)
//   s    the sort order (shared with the other views of the question)
//   cb   which answer variants are open, as a dot-joined list of positions
//
// Every open variant owns a param set of its own, keyed off its own block key; that grammar is the
// open-ended family's and stays with it.

import { isEqual } from 'lodash'

import { hasBase } from '@aytm/app/stats/page/question-views/answer-variants/components/chart/lib/chartModes'
import { isRType as calcIsRType } from '@aytm/app/stats/page/components/lib/utils'
import {
  DEFAULT_SORT_ORDER,
  decodeSortParam,
  encodeSortParam
} from '@aytm/app/stats/page/question-views/components/lib/sort-param'
import { PERCENT_CHART_MODES } from '@aytm/app/stats/page/question-views/components/lib/chart-modes'

export { DEFAULT_SORT_ORDER }

export const resolveSortOrder = (section, defaultSortOrder = DEFAULT_SORT_ORDER) =>
  decodeSortParam(section, { defaultSortOrder })

// A zoom that matches the one the whole report is set to is not the question's own, so the key
// drops out of the persisted set.
export { calcZoomSection } from '@aytm/app/stats/page/question-views/components/lib/zoom-param'

export const calcSortParamsSection = (sortOrder, defaultSortOrder = DEFAULT_SORT_ORDER) => ({
  s: encodeSortParam(sortOrder, { defaultSortOrder })
})

export const resolveChartMode = (params = {}) => params.cm || null

// A block opens with every variant closed, so an empty list is what the param says nothing about.
export const resolveUncollapsed = section => (null == section ? '' : String(section))

export const calcCollapseSection = uncollapsed => ({ cb: uncollapsed?.length ? uncollapsed : null })

// The chart-mode space collapses to percents for a question with a base, or one told to show
// percents only; a question counting respondents has no pie to slice.
export const calcDefaultChartMode = ({
  chartMode,
  questionChartMode,
  globalChartMode,
  answer,
  percentsOnly,
  type
} = {}) => {
  let mode = 'off' === chartMode ? globalChartMode : chartMode
  mode = mode || questionChartMode || globalChartMode

  if (calcIsRType({ type }) && 'pie' === mode) mode = 'respondents'

  if ((hasBase(answer) || true === percentsOnly) && !PERCENT_CHART_MODES.includes(mode)) return 'percents'

  return mode
}

// A chart mode that says what the question already says is not worth storing.
export const calcChartParamsSection = ({ chartMode, questionChartMode, format } = {}) => {
  const stored = format?.chartMode || questionChartMode || 'off'

  return { cm: isEqual(chartMode, stored) ? null : chartMode }
}
